// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"6":"9f1473e9","274":"ac4644c6","381":"ca9f6b30","695":"43b82611","864":"c4135cbf"}[chunkId] + ".css";
};